const MyCustomersSvg = (props: any) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11.8142C11.206 11.8142 13 10.0202 13 7.81421C13 5.60821 11.206 3.81421 9 3.81421C6.794 3.81421 5 5.60821 5 7.81421C5 10.0202 6.794 11.8142 9 11.8142ZM17 13.8142C18.654 13.8142 20 12.4682 20 10.8142C20 9.16021 18.654 7.81421 17 7.81421C15.346 7.81421 14 9.16021 14 10.8142C14 12.4682 15.346 13.8142 17 13.8142ZM22 19.8142C22 20.3662 21.553 20.8142 21 20.8142H16C16 21.3662 15.553 21.8142 15 21.8142H3C2.447 21.8142 2 21.3662 2 20.8142C2 16.9542 5.141 13.8142 9 13.8142C10.927 13.8142 12.673 14.5972 13.94 15.8602C14.809 15.1882 15.879 14.8142 17 14.8142C19.757 14.8142 22 17.0572 22 19.8142Z"
        fill="white"
      />
    </svg>
  )
}

export default MyCustomersSvg
